import {IHeadlineProperties} from '@vfde-brix/headline';
import {IOfferFromJSON} from '../../../../types';
import {createMultiDividerHeadline} from 'Container/OfferDisplay/helpers/components/multideviderHelper';
import {
    OFFER_CARD_BENEFITLIST_HEADLINE,
    OFFER_CARD_BENEFITLIST_IMAGE,
    OFFER_CARD_BENEFITLIST_LIST,
} from 'Container/OfferDisplay/constant';
import {BENEFIT_PUZZLE_ICON_PATH} from 'Constant';

/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * FIND STRUCTURE OF PRICE DETAILS IN readme.md
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 */

const renderBenefitListHeadline = (element: HTMLElement, offer: IOfferFromJSON) => {

    const headlineDIV: HTMLElement = <HTMLElement>element.getElementsByClassName(OFFER_CARD_BENEFITLIST_HEADLINE)[0];
    const headlineProperties: IHeadlineProperties = {
        optTag: 'h3',
        optAlign: 'center',
        stdContent: offer.Card_Headline,
        optVisualLevel: 'h3',
        spacing: '100',
        business: {},
    };

    createMultiDividerHeadline(headlineDIV, headlineProperties);
};

const renderBenefitPuzzleImage = (element: HTMLElement, offer: IOfferFromJSON) => {

    const imageElement: HTMLImageElement = <HTMLImageElement>element.getElementsByClassName(OFFER_CARD_BENEFITLIST_IMAGE)[0];
    imageElement.src = BENEFIT_PUZZLE_ICON_PATH + offer.ID + '.svg';

};

const generateAndAppendListItem = (element: HTMLElement, benefitText: string) => {
    if ('' !== benefitText) {
        const liElement = document.createElement('li');
        liElement.innerHTML = benefitText;
        element.appendChild(liElement);
    }
};

const renderBenefitListItems = (element: HTMLElement, offer: IOfferFromJSON) => {

    const listElement: HTMLUListElement = <HTMLUListElement>element.getElementsByClassName(OFFER_CARD_BENEFITLIST_LIST)[0];
    const benefitListItems = [
        'Mobile_Benefit',
        'Fixed_Benefit',
        'TV_Benefit',
        'RedPlus_Benefit',
        'Bundle_Benefit_1',
        'Bundle_Benefit_2',
        'Bundle_Benefit_3',
    ];
    const benefitListItemsLength = benefitListItems.length;

    for (let i = 0; i < benefitListItemsLength; i++) {
        generateAndAppendListItem(listElement, offer[benefitListItems[i]]);
    }

};

/**
 * renders the multi divider dynamically
 * @param element
 * @param offer
 */
export const renderBenefitList = (element: HTMLElement, offer: IOfferFromJSON) => {

    renderBenefitListHeadline(element, offer);

    renderBenefitPuzzleImage(element, offer);

    renderBenefitListItems(element, offer);

};
